
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationE as ObiLocationEElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-e.js';
 
 
 

 
 export const ObiLocationE = createComponent({
   react: React,
   tagName: 'obi-location-e',
   elementClass: ObiLocationEElement,
   events: {
     
   }
  });
 
 